<template lang="pug">
  #create-program
    WtTitle(h2)
      span.pr-2 Create a Be Well Program

    WtTile(parent :col="12")
      WtTile(child :col="12")
        section.section.card-wrapper
          .create-program-columns.columns
            .column
              ProgramDetails(
                @newProgramDetails="newProgramDetails"
                ref="programDetails"
              )
            .column
              WtTitle(h3) Admin Account
              ProgramAdminDetails(
                @newProgramAdminDetails="newProgramAdminDetails"
                ref="programAdminDetails"
              )
          WtButton(
            @click.native="submitProgramSetup"
            color="primary"
            fullwidth
            :disabled="disableSubmitProgram"
            :loading="processing"
          ) Submit
</template>

<script>
import { mapActions } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import ProgramAdminDetails from "@@/CreateProgram/ProgramAdminDetails";
import ProgramDetails from "@@/CreateProgram/ProgramDetails";

export default {
  name: "SetupPage",

  components: {
    ProgramAdminDetails,
    ProgramDetails,
    WtTile,
    WtButton,
    WtTitle
  },

  data() {
    return {
      programAdminDetailsValid: false,
      programAdminDetailsData: {},
      programDetailsValid: false,
      programDetailsData: {},
      processing: false,
      submitDisabled: true,
      activeProductName: "bewellcore",
      programStoreError: false,
      programCreated: false
    };
  },

  computed: {
    createProgramPayload() {
      return { ...this.programAdminDetailsData, ...this.programDetailsData };
    },

    createProgramPayloadValid() {
      return this.programAdminDetailsValid && this.programDetailsValid;
    },

    seats() {
      return Number(this._.get(this.programDetailsData, "seats", 1));
    },

    disableSubmitProgram() {
      return this.processing || !this.createProgramPayloadValid;
    }
  },

  methods: {
    ...mapActions("program", ["storeProgram"]),
    ...mapActions(["snackBar"]),

    newProgramAdminDetails($event) {
      this.programAdminDetailsValid = $event.isValid;
      this.programAdminDetailsData = $event.formData;
    },

    newProgramDetails($event) {
      this.programDetailsValid = $event.isValid;
      this.programDetailsData = $event.formData;
    },

    async submitProgramSetup() {
      if (this.disableSubmitProgram) {
        return false;
      }

      this.processing = true;

      await this.createProgram();

      this.processing = false;
    },

    async createProgram() {
      if (!this.createProgramPayloadValid) {
        throw Error("invalid program details");
      }

      const programAdminUsername = this.createProgramPayload.programUrl + "pa";
      const payload = {
        name: this.createProgramPayload.programName,
        url: this.createProgramPayload.programUrl,
        timezone: `-5`,
        email: this.createProgramPayload.email,
        username: programAdminUsername,
        firstName: this.createProgramPayload.firstName,
        lastName: this.createProgramPayload.lastName,
        password: this.createProgramPayload.password,
        password_confirmation: this.createProgramPayload.passwordConfirm,
        type: this.createProgramPayload.tiers,
        seats: this.createProgramPayload.seats,
        allowRegistration: 1,
        totalEligibleEmployees: this.createProgramPayload.totalEligibleEmployees
      };

      try {
        await this.storeProgram(payload);
        await this.snackBar({
          type: "is-success",
          duration: 5000,
          message: "Program Created Successfully"
        });

        // reset  model state.
        this.$refs.programDetails.resetState();
        this.$refs.programAdminDetails.resetState();
      } catch (error) {
        console.error(error);

        await this.snackBar({
          type: "is-danger",
          duration: 10000,
          queue: false,
          message: error.response
        });

        this.programStoreError = true;
      }
    }
  }
};
</script>
